import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import { canSeeMerchants } from "@/lib/roles";

/** The Merchants pages are for Myela staff roles only; anyone else lands on Home. */
export function MerchantsOnly({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!user) return null;
  return canSeeMerchants(user.roles) ? <>{children}</> : <Navigate to="/" replace />;
}
